/* pulled in from https://codepen.io/qt-dork/pen/YPwjvwp */
class SplitText extends HTMLElement {
  static observedAttributes = ["delay"];

  constructor() {
    super();
  }

  connectedCallback() {
    // ?? is called "nullish coalescence".
    // if the returned value is "nullish", then return the other value
    const delay = parseFloat(this.getAttribute("delay") ?? 0.3);

    const text = this.textContent;
    const out = text
      .split("")
      .map((char, i) => `<span style="--i:${i * delay};">${char}</span>`)
      .join("");

    this.innerHTML = out;
  }
}

customElements.define("wavy-text", 
  class extends SplitText {}
)
